import React, { useState } from 'react';
import ModalLeave from '../ModalLeave';
import { BackButton, CloseButton, Container, Tittle } from './styled';
import { usePublicationRouter } from '@contexts/PropertyListingPublications/components/shared';

export const NavBar = () => {
  const router = usePublicationRouter();

  const [ShowCloseModal, setShowCloseModal] = useState(false);

  const onClose = async () => {
    if (router.isLastStep) {
      // send the user to main publications page
      return router.goToPublicationsPage();
    } else {
      setShowCloseModal(true);
    }
  };

  return (
    <Container>
      {ShowCloseModal && (
        <ModalLeave onClose={() => setShowCloseModal(false)} isPublish={true} />
      )}
      {router.hasGoBack && (
        <BackButton
          src="/images/LeftArrow.svg"
          alt="Icono Flecha Abajo | Aptuno"
          title="Icono Flecha Abajo | Aptuno"
          onClick={() => router.goToPreviousStep()}
        />
      )}
      <Tittle hasGoBack={router.hasGoBack}>Publicar inmueble</Tittle>
      <CloseButton
        src="/images/CrossButton.svg"
        alt="Icono de Cross"
        title="Icono de Cross | Aptuno"
        onClick={onClose}
      />
    </Container>
  );
};
